import * as Yup from 'yup';

export const manufacturerSchema = Yup.object().shape({
  Id: Yup.string(),
  nome: Yup.string().default('').required('Campo obrigatório'), 
  codigo: Yup.string().default('').required('Campo obrigatório'),
  contato: Yup.string().default('').required('Campo obrigatório'),
  email: Yup.string().default('').required('Campo obrigatório'),
  endereco: Yup.string().default('').required('Campo obrigatório'),
});